import {ChangeEvent, useCallback, useMemo, useState} from 'react';
import 'reactflow/dist/style.css';
import ReactFlow, {
    applyEdgeChanges,
    applyNodeChanges,
    Background,
    Controls,
    Edge,
    EdgeChange,
    NodeChange,
} from 'reactflow';
import {useSmartTriggerConfiguration} from "../../context/smartTriggerConfigurationProvider";
import ButtonEdge from "../edges/buttonEdge";
import MainProcessorNodeComponent from "../nodes/processors/main/mainProcessorNodeComponent";
import AddProcessorNodeComponent from "../nodes/processors/add/addProcessorNodeComponent";
import {StartProcessorNodeComponent} from "../nodes/processors/start/startProcessorNodeComponent";
import {SmartTriggerConfiguration, SmartTriggerProcessorNodeConfiguration} from "../../types";
import './smartTriggerFlowConfigurationComponent.css'
import {Button, Switch, Textarea, TextInput} from "@mantine/core";
import {BugOff, CloudUpload, PlayerPlay} from "tabler-icons-react";
import {StringUtils} from "../../../../utils/stringUtils";
import {ObjectUtils} from "../../../../utils/objectUtils";
import {pushSmartTrigger, toSmartTriggerConfiguration} from "../../service/smartTriggerService";
import {useAuth} from "../../../../providers/AuthProvider";
import {NotificationProcessor} from "../nodes/notification/notificationProcessor";

const edgeTypes = {
    buttonEdge: ButtonEdge,
};


export default function SmartTriggerFlowConfigurationComponent() {
    const smartTriggerConfiguration = useSmartTriggerConfiguration();
    const {
        nodes,
        edges,
        setNodes,
        setEdges,
        name,
        description,
        author,
        setConfiguration
    } = smartTriggerConfiguration;


    const smartTriggerNodeTypes = useMemo(() => ({
        script: MainProcessorNodeComponent,
        add: AddProcessorNodeComponent,
        start: StartProcessorNodeComponent,
        notification: NotificationProcessor
    }), []);

    const authContext = useAuth();

    const [errors, setErrors] = useState<Record<keyof SmartTriggerConfiguration, string>>({} as any);


    const onNodesChange =
        useCallback((changes: NodeChange[]) => setNodes((nd: SmartTriggerProcessorNodeConfiguration[]) => {
            let nodeChanges = applyNodeChanges(changes, nd) as SmartTriggerProcessorNodeConfiguration[];
            console.log(nodeChanges)
            return nodeChanges;
        }), [nodes, setNodes]);

    const onEdgesChange = useCallback(
        (changes: EdgeChange[]) => setEdges((eds: Edge[]) => applyEdgeChanges(changes, eds)),
        [edges, setEdges]
    );

    function updateConfig(key: keyof SmartTriggerConfiguration, event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
        const value = event.currentTarget.value;
        setConfiguration({
            [key]: value
        })
    }

    function validate() {
        const validationErrors = {} as Record<keyof SmartTriggerConfiguration, string>
        if (StringUtils.isBlank(name)) {
            validationErrors.name = "Please provide the name";
        }
        if (StringUtils.isBlank(author)) {
            validationErrors.author = "Please provide your name as author."
        }
        if (StringUtils.isBlank(description)) {
            validationErrors.description = 'Please provide some description'
        }
        return validationErrors;
    }

    async function validateAndSave() {
        const validationErrors = validate();
        if (!ObjectUtils.isEmpty(validationErrors)) {
            setErrors(validationErrors);
            return;
        }

        const configurationData = toSmartTriggerConfiguration(smartTriggerConfiguration);
        const response = await pushSmartTrigger(authContext, configurationData);
        alert(JSON.stringify(response))

    }

    return (
        <div className="smart-trigger-container">
            <div className="smart-trigger-flow">
                <ReactFlow
                    nodes={nodes}
                    onNodesChange={onNodesChange}
                    edges={edges}
                    onEdgesChange={onEdgesChange}
                    nodeTypes={smartTriggerNodeTypes}
                    edgeTypes={edgeTypes}
                    zoomOnScroll={false}
                    panOnScroll={true}
                    preventScrolling={false}
                    fitView={true}
                    panOnScrollMode={"vertical" as any}
                >
                    <Background/>
                    <Controls/>
                </ReactFlow>
            </div>
            <div className="smart-trigger-configuration">
                <div className={"configuration-box-title"}>
                    <h4>CONFIGURATION</h4>
                    <Switch className={"active-switch"} color={"teal"} size="lg" onLabel="ACTIVE"
                            offLabel="INACTIVE"/>
                </div>
                <div className="configuration-box">

                    <hr className={"common-divider"}/>
                    <div className="form-element">
                        <TextInput value={name}
                                   error={errors['name']}
                                   onChange={event => updateConfig('name', event)}
                                   placeholder={"Smart Trigger Name"} label={"Name"}/>
                    </div>
                    <div className="form-element">
                        <TextInput value={author}
                                   error={errors['author']}
                                   onChange={event => updateConfig('author', event)}
                                   placeholder={"Please provide your name"} label={"Owner"}/>
                    </div>
                    <div className="form-element">
                        <Textarea value={description}
                                  error={errors["description"]}
                                  onChange={event => updateConfig('description', event)}
                                  placeholder={"Please mention about this smart trigger"}
                                  label={"Description"}/>
                    </div>
                </div>
                <hr className={"common-divider"}/>

                <div className={"smart-trigger-configuration-run-config"}>
                    <Button color={"teal"} rightIcon={<PlayerPlay/>} size={"xs"} variant="outline">
                        RUN
                    </Button>
                    <Button color={"dark"} rightIcon={<BugOff/>} size={"xs"} variant="outline">
                        TEST
                    </Button>
                </div>


                <hr className={"common-divider"}/>
                <div className={"smart-trigger-configuration-footer"}>
                    <Button onClick={() => validateAndSave()} color={"teal"} rightIcon={<CloudUpload/>} size={"sm"}
                            variant="filled">
                        SAVE
                    </Button>
                </div>

            </div>
        </div>

    );
}


